import { Router } from '@angular/router';
import { ResponseDTO } from '../dtos/response-dto';
import { RespostaMarcacaoConsultaDTO } from '../dtos/resposta-marcacao-consulta-dto';
import { RespostaMarcacaoDTO } from '../dtos/resposta-marcacao-dto';
import { Util } from '../util/util';
import { MarcacaoConsulta } from './marcacao-consulta/marcacao-consulta';
import { Marcacao } from './marcacao-procedimento/marcacao';
import { TipoMarcacaoEnum } from '../enums/tipo-marcacao-enum';

export abstract class MarcacaoComponent {
  marcacaoConsulta: MarcacaoConsulta = new MarcacaoConsulta();

  marcacaoProcedimento: Marcacao = new Marcacao();

  usuarioLogado: ResponseDTO;

  tituloDaEtapaAtual = '';

  respostaMarcacao: RespostaMarcacaoDTO;

  constructor(protected router: Router) {
    this.usuarioLogado = JSON.parse(
      localStorage.getItem('currentUser') || '{}'
    );

    if (!this.usuarioLogado.username) {
      this.usuarioLogado = new ResponseDTO(null, null, null);
    }

    this.marcacaoConsulta = history.state.marcacaoConsulta;

    if (!this.marcacaoConsulta) {
      this.marcacaoConsulta = new MarcacaoConsulta();
    }

    this.respostaMarcacao = new RespostaMarcacaoConsultaDTO(
      '',
      this.marcacaoConsulta
    );

    this.marcacaoProcedimento = history.state.marcacaoProcedimento;

    if (!this.marcacaoProcedimento) {
      this.marcacaoProcedimento = new Marcacao();
    }
  }

  abstract telaAnterior(): void;

  abstract proximaTela(): void;

  configurarTitulo(
    textoComplementar: string,
    tipoMarcacao: TipoMarcacaoEnum
  ): void {
    if (tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {
      this.tituloDaEtapaAtual = 'Marcação de Exames ' + textoComplementar;
    } else if (tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {
      this.tituloDaEtapaAtual = 'Marcação de Consultas ' + textoComplementar;
    }
  }

  validarCadastroPaciente(): void {
    return;
    if (!this.marcacaoConsulta) {
      this.router.navigate(['/']);
    } else if (
      !this.marcacaoConsulta.paciente ||
      this.marcacaoConsulta.paciente.id == 0
    ) {
      this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
        state: {
          tipoMarcacao: this.marcacaoConsulta.tipoMarcacao,
        },
      });
    }
  }

  validarTelaSelecaoPaciente(): void {
    return;
    if (!this.marcacaoConsulta) {
      this.router.navigate(['/']);
    } else if (
      !this.marcacaoConsulta.pacienteSelecionado ||
      this.marcacaoConsulta.pacienteSelecionado.id == 0 ||
      !this.marcacaoConsulta.planoSaude ||
      this.marcacaoConsulta.planoSaude.id == 0
    ) {
      this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
        state: {
          tipoMarcacao: this.marcacaoConsulta.tipoMarcacao,
        },
      });
    }
  }

  configurarMarcacaoProcedimento(): void {
    this.marcacaoProcedimento.pacienteSelecionado =
      this.marcacaoConsulta.pacienteSelecionado;
    this.marcacaoProcedimento.planoSaude = this.marcacaoConsulta.planoSaude;
  }

  horaFormatada(hora: string): string {
    return Util.getHoraFormatada(hora);
  }

  restaurarMarcacaoConsultaApartirDaTelaDeSelecaoDeExames(): void {
    this.marcacaoConsulta.pacienteSelecionado =
      this.marcacaoProcedimento.pacienteSelecionado;
    this.marcacaoConsulta.planoSaude = this.marcacaoProcedimento.planoSaude;
    this.marcacaoConsulta.portadorNecessidade =
      this.marcacaoProcedimento.portadorNecessidade;
    this.marcacaoConsulta.tipoMarcacao = this.marcacaoProcedimento.tipoMarcacao;
  }
}
